import MovingUnitIndicator from './MovingUnitIndicator';
export default MovingUnitIndicator;
